import { render, staticRenderFns } from "./myEnrollInfo.vue?vue&type=template&id=5674d74d&scoped=true"
import script from "./myEnrollInfo.vue?vue&type=script&lang=js"
export * from "./myEnrollInfo.vue?vue&type=script&lang=js"
import style0 from "./myEnrollInfo.vue?vue&type=style&index=0&id=5674d74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674d74d",
  null
  
)

export default component.exports